import { Country } from '../constants';
export function getCountryName(code) {
    return Country[code];
}
